import { render, staticRenderFns } from "./completeLink.vue?vue&type=template&id=7d48ecb9&scoped=true"
import script from "./completeLink.vue?vue&type=script&lang=js"
export * from "./completeLink.vue?vue&type=script&lang=js"
import style0 from "./completeLink.vue?vue&type=style&index=0&id=7d48ecb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48ecb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d48ecb9')) {
      api.createRecord('7d48ecb9', component.options)
    } else {
      api.reload('7d48ecb9', component.options)
    }
    module.hot.accept("./completeLink.vue?vue&type=template&id=7d48ecb9&scoped=true", function () {
      api.rerender('7d48ecb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/completeLink.vue"
export default component.exports